/**
 * Trigger: tr_currencies_hard_delete
 * Purpose: Cascade delete and update positions when a currency is hard deleted
 * Table: currencies
 * Event: BEFORE DELETE
 */
export const TR_CURRENCIES_HARD_DELETE = `
CREATE TRIGGER tr_currencies_hard_delete
BEFORE DELETE ON currencies
FOR EACH ROW
BEGIN
  DELETE FROM account_daily_balances WHERE currency_id = old._id;
  DELETE FROM account_balances WHERE currency_id = old._id;
  DELETE FROM planned_expenses WHERE currency_id = old._id;
  DELETE FROM planned_incomes WHERE currency_id = old._id;
  DELETE FROM expenses WHERE currency_id = old._id;
  DELETE FROM incomes WHERE currency_id = old._id;
  DELETE FROM account_initial_balances WHERE currency_id = old._id;
  DELETE FROM account_transfers WHERE currency_id = old._id;
  DELETE FROM creditors WHERE currency_id = old._id;
  DELETE FROM creditor_payments WHERE currency_id = old._id;
  DELETE FROM debtors WHERE currency_id = old._id;
  DELETE FROM debtor_payments WHERE currency_id = old._id;
  DELETE FROM exchanges WHERE currency_in_id = old._id OR currency_out_id = old._id;
  DELETE FROM exchange_rates WHERE currency_id = old._id;

  UPDATE currencies
  SET position = position - 1,
      updated_at = strftime('%s', 'now')
  WHERE position > old.position
    AND is_deleted = 0;

  UPDATE currencies
  SET is_default = 1
  WHERE old.is_default = 1
    AND is_deleted = 0
    AND position = (
      SELECT min(position) FROM currencies
      WHERE is_deleted = 0 AND _id <> old._id
    );
END;
`;
